import styled from '@emotion/styled'
import { theme } from '@hhgtech/hhg-components'

export const StyledPopupBody = styled.div`
  padding: 0 16px 32px 16px;
  text-align: center;
`

export const StyledThankyouBanner = styled.img`
  width: 280px;
  height: 280px;
  margin: 16px auto 0 auto;
`

export const StyledThankyouTitle = styled.h3`
  font-size: 26px;
  font-weight: 700;
  line-height: 36px;
`

export const StyledThankyouDescription = styled.p`
  margin-top: 8px;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: -0.2px;
  line-height: 28px;
`

export const StyledFinishButton = styled.button`
  padding: 12px 16px;
  margin-top: 58px;
  background-color: ${theme.colors.primaryBase};
  border-radius: ${theme.borderRadius};
  color: ${theme.colors.white};
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
`
